import { useEffect, useState } from 'react';

import { useAtom, useSetAtom } from 'jotai';
import { settingPopOpenAtom } from '@/components/setting/users/ProfileSectionCard';

import styled from 'styled-components';
import { buttonBaseStyle } from '@/styles/constant';
import { Button, TextField, Typography } from '@mui/material';

import { patchUserAtom, userInfoAtom } from '@/interfaces/member';
import { useTranslation } from 'react-i18next';
import { type ErrorInfo, getErrInfo } from '@/components/common/utils';

interface Props {
  name: string;
}

const Layout = styled.div`
  padding: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;

export default function PopupSetName({ name }: Props) {
  const { t } = useTranslation();
  const [userName, setUserName] = useState(name);
  const [{ data, mutate, status, error }] = useAtom(patchUserAtom);

  const setOpenTarget = useSetAtom(settingPopOpenAtom);
  const [{ refetch }] = useAtom(userInfoAtom);

  useEffect(() => {
    if (data && status) {
      refetch();
      setOpenTarget({ open: '' });
    } else if (status === 'error' && error) {
      const errInfo: ErrorInfo = getErrInfo(error);
      let errMsgKey = errInfo.headerCode ? 'Common.message.serverErrorOccurred' : 'Common.message.unknownErrorOccurred';
      switch (errInfo.bodyCode) {
        // case 'EMAIL_ALREADY_EXIST':
        //   errMsgKey = 'Signup.alreadyExist';
        //   break;
        default:
          errMsgKey = errInfo.commonMsgKey !== null && errInfo.commonMsgKey;
          break;
      }
      alert(t(errMsgKey));
    }
  }, [data, status, error]);

  const handleCloseClick = () => {
    mutate({ name: userName });
  };

  return (
    <Layout>
      <TextField
        id="Name"
        label={t('Common.label.name')}
        variant="standard"
        fullWidth={true}
        value={userName}
        onChange={(e) => setUserName(e.target.value)}
      />
      <Button
        variant="contained"
        sx={{
          ...buttonBaseStyle,
          width: 300,
          height: 44,
          borderRadius: 22,
        }}
        color="info"
        onClick={handleCloseClick}
      >
        <Typography fontWeight="medium">{t('Common.label.registButton')}</Typography>
      </Button>
    </Layout>
  );
}
